import { get } from "lodash";

export const AUTH0 = "AUTH0";
export const GOOGLE_OAUTH = "GOOGLE_OAUTH";
export const PAYCHEX_OAUTH = "PAYCHEX_OAUTH";

export type IdentityProvider =
  | typeof AUTH0
  | typeof GOOGLE_OAUTH
  | typeof PAYCHEX_OAUTH;

export const identityProviderToEnglishMapping: Record<
  IdentityProvider,
  string
> = {
  [AUTH0]: "Email & Password",
  [GOOGLE_OAUTH]: "Google SSO",
  [PAYCHEX_OAUTH]: "Paychex SSO",
};

export function identityProviderLabel(identityProvider?: string | null) {
  return get(
    identityProviderToEnglishMapping,
    identityProvider as IdentityProvider,
    "Unknown"
  );
}
